window.initBymoqaMotion = function (app) {

    const header = app.header;

    function breathe() {

        header.animate(
            [
                {
                    transform:
                        "translateX(-50%) scale(1)"
                },
                {
                    transform:
                        "translateX(-50%) scale(1.006)"
                },
                {
                    transform:
                        "translateX(-50%) scale(1)"
                }
            ],
            {
                duration: 5200,
                easing: "ease-in-out"
            }
        );

    }

    breathe();


// Save it for future cleanup if needed
// app.motion.breatheInterval = breatheInterval


    header.animate(
        [
            {
                opacity:0,
                transform:"translateX(-50%) translateY(-40px) scale(.93)"
            },
            {
                opacity:1,
                transform:"translateX(-50%) translateY(0px) scale(1.02)"
            },
            {
                opacity:1,
                transform:"translateX(-50%) translateY(0px) scale(1)"
            }
        ],
        {
            duration:900,
            easing:"cubic-bezier(.22,1,.36,1)"
        }
    );

}